<div class="{{ customClass }}"><ng-content></ng-content></div> 